import api, { runWithAuthSessionLock } from '../../../services/api'
import { clearAuthSession } from '../../../services/authSession'

export const checkNickname = (nickname) => api.get('/members/check-nickname', { params: { nickname } })
export const signUpWithEmail = (payload) => api.post('/members/email', payload)

export const loginWithEmail = (credentials, clientInstanceId) => api.post(
  '/auth/login/email',
  credentials,
  { headers: { 'X-Client-Instance-Id': clientInstanceId } },
)

export const issueEmailVerificationCode = (payload) => api.post('/auth/email-verifications/codes', payload)
export const verifyEmailCode = (payload) => api.post('/auth/email-verifications', payload)
export const resetPassword = (payload) => api.patch('/auth/password-reset', payload)
export const changePassword = (payload) => api.patch('/auth/me/password', payload)
export const revokeCurrentRefreshToken = async () => {
  const result = await runWithAuthSessionLock(
    () => api.delete('/auth/tokens/refresh/current', { _skipAuthRefresh: true }),
  )
  clearAuthSession()
  return result
}

export const revokeAllRefreshTokens = async () => {
  const result = await runWithAuthSessionLock(
    () => api.delete('/auth/tokens/refresh', { _skipAuthRefresh: true }),
  )
  clearAuthSession()
  return result
}
